import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LibCoreSharedModule } from "lib-core-shared";
import { LibUiSharedModule } from "lib-ui-shared";
import { ProductCreatePageComponent } from "./product-create-page.component";
import { ProducCreateRoutingModule } from "./product-create.routing.module";


@NgModule({
    declarations: [
      ProductCreatePageComponent,
    ],
    imports: [
      LibUiSharedModule,
      LibCoreSharedModule,
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      ProducCreateRoutingModule,
      ReactiveFormsModule,
      NgbModule
    ],
  })
  export class ProductCreateModule { }